import { createColumnHelper } from '@tanstack/react-table';

import { FileData } from '../types';

export const columnHelper = createColumnHelper<FileData>();
